module.exports = __webpack_public_path__ + "static/media/lucy.1face529.jpg";